<template>
    <carousel
            :per-page="1"
            :mouse-drag="false"
            :autoplay="true"
            :autoplay-timeout=4000
            :navigation-enabled="false"
            :loop="true"
            class="routa-carousel"
    >
        <slide class="routa-slide">
            <h2 class="carousel-title blue">{{ $t('landing.title')}}</h2>
            <span class="landing-text">{{ $t('landing.descr')}}</span>
        </slide>
        <slide class="routa-slide">
            <h2 class="carousel-title blue">{{ $t('landing.title1')}}</h2>
            <span class="landing-text">{{ $t('landing.descr1')}}</span>
        </slide>
        <slide class="routa-slide">
            <h2 class="carousel-title blue">{{ $t('landing.title2')}}</h2>
            <span class="landing-text">{{ $t('landing.descr2')}}</span>
        </slide>
        <slide class="routa-slide slide4">
            <h2 class="carousel-title blue">{{ $t('landing.title3')}}</h2>
            <span class="landing-text">{{ $t('landing.descr3')}}</span>
        </slide>
        <slide class="routa-slide slide5">
            <h2 class="carousel-title blue">{{ $t('landing.title4')}}</h2>
            <span class="landing-text">{{ $t('landing.descr4')}}</span>
        </slide>
        <slide class="routa-slide slide6">
            <h2 class="carousel-title blue">{{ $t('landing.title5')}}</h2>
            <span class="landing-text">{{ $t('landing.descr5')}}</span>
        </slide>
        <slide class="routa-slide slide7">
            <h2 class="carousel-title blue">{{ $t('landing.title6')}}</h2>
            <span class="landing-text">{{ $t('landing.descr6')}}</span>
        </slide>
    </carousel>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel'
    import bg2 from "../assets/road.png";
    import bg3 from "../assets/snowroad2.png";
    import bg4 from "../assets/inspection.png";
    import bg5 from "../assets/playground.png";
    import bg6 from "../assets/fleet.png";


    export default {
        name: "RoutaCarousel",
        components: {
            Carousel,
            Slide
        },
        data: function () {
            return {
                slide: 0,
                bg1: "'@/assets/routaweb.png'",
                slide2: { backgroundImage: 'url(${require("../assets/road.png")})'},
                slide3: { backgroundImage: 'url($require("@/assets/snowroad2.png"))'},
                slide4: { backgroundImage: url(require("../assets/inspection.png"))},
                slide5: { backgroundImage: 'url(require("@/assets/playground.png"))'},
                slide6: { backgroundImage: url($require("../assets/fleet.png"))},
                slide7: { backgroundImage: url($require("../assets/time.png"))}
            }
        },
        computed: {
          slide1() {
            return {backgroundImage: 'url${require("../assets/routaweb.png")}'}
          }
        },
        methods: {
            openServices: function () {
                this.$emit('scrollTo', 'services')
            },
            openCarrio: function () {
                this.$emit('scrollTo', 'carrio')
            },
            openCareers: function () {
                this.$emit('scrollTo', 'careers')
            },
            openContacts: function () {
                this.$emit('scrollTo', 'contacts')
            }
        }
    }
</script>
